import React from 'react';
import { FormSeller } from './FormSeller';
import { DeleteSeller } from './DeleteSeller';
import { Dialog } from "primereact/dialog";
import { Button } from 'reactstrap'


export const ModalSeller = (props) => {

    const {
        modal, toggle, modalTitle, method, loading,
        name, paternal_surname, maternal_surname, number_phone, email, handleInputChange,
        saveCreate, saveUpdate, saveDelete, validaciones, closeModalSeller,
        arraySeller, loadingSeller
    } = props;





    console.log("🚀 ~ ModalSeller ~ arraySeller:", arraySeller.length)
    const dialogTheme = method === "delete"
        ? `seller-dialog seller-danger ${arraySeller.length === 0 ? "seller-small-v" : "seller-small-1"}`
        : "seller-dialog seller-blue seller-large ";





    return (
        <Dialog
            visible={modal}
            onHide={closeModalSeller}
            modal
            closable={false}
            dismissableMask={false}
            maskClassName="custom-total-mask"

            header={
                <div className="seller-dialog-header">
                    <div className="seller-dialog-header__content">

                        <div className="seller-dialog-icon">
                            <i className="fa fa-briefcase"></i>
                        </div>

                        <div>
                            <div className="seller-dialog-title">
                                {modalTitle}
                            </div>


                        </div>

                    </div>
                </div>
            }
            className={`seller-dialog ${dialogTheme}`}
            blockScroll={true}

            footer={
                <>
                    {
                        method === "create" && <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={saveCreate}
                            disabled={loading}
                        >
                            {loading ? "Guardando" ?? "--" : "Guardar" ?? "---"}
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={saveUpdate}
                            disabled={loading}
                        >
                            {loading ? "Actualizar" ?? "--" : "Actualizar" ?? "---"}
                        </Button>
                    }
                    {
                        // * DELETE
                    }
                    {
                        //arraySeller
                        (method !== "update" && method !== "create" && arraySeller.length === 0) && <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={saveDelete}
                            disabled={loading}
                        >
                            {loading ? "Eliminando..." : "Sí, eliminar"}
                        </Button>
                    }
                    {
                        <Button
                            size="sm"
                            color="danger"
                            type="button"
                            onClick={closeModalSeller}
                            disabled={loading}
                        >
                            {"Cancelar" ?? "---"}
                        </Button>
                    }



                </>
            }
        >
            {
                method === "create" ?
                    <FormSeller
                        button="Crear"
                        {...{ toggle, loading, name, paternal_surname, maternal_surname, number_phone, email, handleInputChange, validaciones, closeModalSeller, methodAction: saveCreate }}
                    />
                    : (method === "update") ?
                        <FormSeller
                            button="Actualizar vendedor"
                            {...{ toggle, loading, name, paternal_surname, maternal_surname, number_phone, email, handleInputChange, validaciones, closeModalSeller, methodAction: saveUpdate }}
                        />
                        : <DeleteSeller
                            {...{ closeModalSeller, loading, name, saveDelete, arraySeller, loadingSeller }}
                        />
            }
        </Dialog>
    )
}
